/**
 * Rendez-vous express : une réunion courte à deux, proposée depuis la fiche d'un membre.
 * Aucune route dédiée : c'est une réunion ordinaire du module Réunions (invitation,
 * notification, agenda, export .ics et plafond du plan viennent avec).
 */

export const DUREES_EXPRESS = [10, 15, 20, 30];
export const DUREE_EXPRESS_DEFAUT = 15;

const deux = (n) => String(n).padStart(2, '0');

/** Date locale au format « AAAA-MM-JJTHH:MM:SS », celui que le serveur lit sans décalage de fuseau. */
export function formaterDateLocale(date) {
    return `${date.getFullYear()}-${deux(date.getMonth() + 1)}-${deux(date.getDate())}`
        + `T${deux(date.getHours())}:${deux(date.getMinutes())}:${deux(date.getSeconds())}`;
}

/** Fin du rendez-vous = début + durée, ou chaîne vide si le début est illisible. */
export function finDuRendezVous(debut, minutes) {
    const d = new Date(debut);
    if (!debut || Number.isNaN(d.getTime())) return '';
    return formaterDateLocale(new Date(d.getTime() + Number(minutes) * 60000));
}

/**
 * Le corps envoyé à POST /meetings.
 * @param {object} p
 * @param {number} p.creatorId
 * @param {number} p.targetId - Le membre invité
 * @param {string} p.title
 * @param {string} p.debut - Date et heure de début
 * @param {number} p.minutes
 * @param {'in_person'|'video'|'phone'} p.type
 * @param {string} p.lieu - Adresse ou nom du lieu (en personne)
 * @param {string} p.lien - Lien de visioconférence (vidéo)
 * @param {string} p.message
 */
export function construireRendezVousExpress({ creatorId, targetId, title, debut, minutes, type, lieu = '', lien = '', message = '' }) {
    return {
        creatorId,
        title,
        description: message.trim(),
        meetingDate: formaterDateLocale(new Date(debut)),
        endDate: finDuRendezVous(debut, minutes),
        durationMinutes: Number(minutes),
        meetingType: type,
        placeName: type === 'in_person' ? lieu.trim() : '',
        videoLink: type === 'video' ? lien.trim() : '',
        notes: '',
        participants: [{ id: targetId, isRequired: true }]
    };
}

/** Ce qui manque pour pouvoir envoyer : clés d'erreur, vides si tout est bon. */
export function erreursRendezVousExpress({ debut, type, lieu = '', lien = '' }) {
    const erreurs = {};
    const d = new Date(debut);
    if (!debut || Number.isNaN(d.getTime())) erreurs.debut = 'debut';
    else if (d.getTime() < Date.now()) erreurs.debut = 'passe';
    if (type === 'video' && !/^https:\/\//i.test((lien || '').trim())) erreurs.lien = 'lien';
    if (type === 'in_person' && !(lieu || '').trim()) erreurs.lieu = 'lieu';
    return erreurs;
}
